<template>
  <v-main>
    <DetailsDialog ref="detailsDialog" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      @rowClicked="showRowDetails"
    />
  </v-main>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import DetailsDialog from './DetailsDialog'
import { fullSpec } from './rdevents-columns'

export default {
  pageTitle: 'Histórico de Eventos RD',
  components: {
    GenericReport,
    DetailsDialog
  },
  data() {
    return {
      reportSpec: {
        code: 'globalRDEventsHistory',
        title: 'Hist. Eventos',
        apiBase: '/rawdata-events',
        filters: [
          'DateRange',
          { type: 'RDEventType', prefix: 'types', noSuffix: true },
          { type: 'Keywords', prefix: 'str0', label: 'str0', showInMenu: true },
          { type: 'Keywords', prefix: 'str1', label: 'str1', showInMenu: true }
        ]
      },

      adapterSpec: fullSpec
    }
  },
  methods: {
    showRowDetails({ row }) {
      this.$refs.detailsDialog.open(row.id)
    }
  }
}
</script>

<style></style>
